import { render } from "./markdownCode.vue?vue&type=template&id=11695109&scoped=true"
import script from "./markdownCode.vue?vue&type=script&lang=js"
export * from "./markdownCode.vue?vue&type=script&lang=js"

import "./markdownCode.vue?vue&type=style&index=0&id=11695109&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11695109"]])

export default __exports__